<template>
    <div class="event-view">
      <v-card flat v-if="loading">
        <v-card-text>
          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
      <div v-else>
        <v-card flat v-if="Info">
          <PrintViewBar :id="Info.id" type="event"
            :title="`Event: ${Info.name}`" :postfix="`view?key=${Info.Business.code}`"
            :name="Info.Business.name" />
  
            <v-container fluid>
              <v-card-text class="pb-0">
                <v-layout row>
                  <v-flex class="text-left text-capitalize">
                    <div class=" headline font-weight-bold">
                      {{ Info.Business.name }}
                    </div>
                    <div class="font-weight-medium">
                      {{ Info.Business.address }} {{ Info.Business.city }},
                      <span class="text-uppercase">{{ Info.Business.state }}
                      </span>
                      {{ Info.Business.zip }}
                    </div>
                    <div class="font-weight-medium">
                      {{ Info.Business.phoneNumber }}
                    </div>
                    <div class="font-weight-medium text-lowercase">
                      {{ Info.Business.email }}
                    </div>
                    <div class="font-weight-medium text-lowercase">
                      {{ Info.Business.website }}
                    </div>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-right">
                    <div v-if="!$vuetify.breakpoint.xsOnly">
                      <img v-if="Info.Business.imageUrl" height="120" class="logo mb-3" :src="Info.Business.imageUrl"
                        alt="" />
                    </div>
                    <div class="font-weight-regular">
                      <v-row>
                        <v-col class="pb-0">EVENT:</v-col>
                        <v-col class="pb-0">{{Info.name}}</v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-0">CREATED: </v-col>
                        <v-col class="py-0">{{ Info.createdAt | moment("from", "now") }}</v-col>
                      </v-row>
                    </div>
                  </v-flex>
                  <v-card class="mt-5 rounded-xl">
                    <v-img contain :src="Info.imageUrl"></v-img>
                  </v-card>
                </v-layout>      
              </v-card-text>
              <v-card-text class="pt-0 mt-5">
                <v-data-table  dense :headers="headers" sort-by="name"
                  :itemsPerPage="Info.EventDetails.length" hide-default-footer :items="Info.EventDetails">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        {{ item.name }}
                      </td>
                      <td class="text-left">
                        {{ item.phoneNumber }}
                      </td>
                      <td class="text-left">
                        {{ item.email }}
                      </td>
                      <td  class="text-right">
                        {{ item.amount | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-container>
        </v-card>
      </div>
    </div>
  </template>
  <script>
  import EventDataService from "@/modules/Events/service.js";
  import PrintViewBar from "@/components/PrintViewBar";
  import Hashids from "hashids";
  const hashids = new Hashids();
  
  export default {
    name: "event-info",
    data() {
      return {
        EventDataId: null,
        EventData: {
          name: null,
          email: null,
          age: null,
          phoneNumber: null,
        },
        headers: [
          {
            text: "NAME",
            align: "left",
            value: "eventDetail.name",
            sortable: false,
          },
          {
            text: "Contact",
            align: "left",
            value: "eventDetail.phoneNumber",
            sortable: false,
          },
          {
            text: "Email",
            align: "left",
            value: "eventDetail.email",
            sortable: false,
          },
          {
            text: "Amount",
            align: "right",
            value: "amount",
            sortable: false,
          },
        ],
        loading: false,
        notFound: false,
        showValue: false,
        cardCollected: false,
        Info: null,
      };
    },
  
    created() {
      this.loadData();
    },
  
    components: {
      PrintViewBar
    },

    methods: {
      loadData() {
        const id = hashids.decode(this.$route.params.id);
  
        return EventDataService
          .getPublicEventById(id)
          .then((response) => {
            console.log("response new", id, response);
            if (response.data) {
              this.Info = response.data;
              this.EventDataId = this.Info.id
              // this.StripeKey = this.Info.Info.Business.metadata.publicStripeId;
              // this.cardCollected = this.Info.isCollected;
              document.title = this.Info.Info.Business.name;
            } else {
              // console.log("asdkfjaslkdfjlaksjdf;lkasjdf");
              this.notFound = true;
            }
  
            // this.Donor = response.data;
            // console.log('response.data.alert', response)
            // if (response.data && !response.data.alert) response.data.alert = false
            this.$Progress.finish();
          })
          .catch(() => {
            this.loading = false
            this.$Progress.finish();
          });
      },
    },
  };
  </script>
  
  <style scoped></style>